__turbopack_context__.v({
  "SampleLibraryPage__Breadcrumbs": "BNoMna_SampleLibraryPage__Breadcrumbs",
});
